export { default as IconCross } from "./icon-cross.vue";
